module.exports = __webpack_public_path__ + "img/icon-borrow-eos-usdt.e281b8db.svg";